(function (factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') api.mount(window);
})(function () {
  'use strict';
  function installmentQuote(total, currency) {
    if (currency !== 'EUR' || !Number.isSafeInteger(total) || total < 2000 || total > 200000) return null;
    return { amount: Math.floor(total / 3), equal: total % 3 === 0 };
  }
  function mount(win) {
    const doc = win.document, controllers = new Map();
    function initialize(scope) {
      const roots = scope?.matches?.('[data-fas-garden]') ? [scope] : (scope || doc).querySelectorAll('[data-fas-garden]');
      for (const root of roots) {
        if (controllers.has(root)) continue;
        const island = root.querySelector('.fg-buy-island[data-fas-payment-currency]');
        const price = island?.querySelector('[data-fas-installment-price]');
        const amount = price?.querySelector('[data-fas-installment]');
        const cadence = price?.querySelector('[data-fas-installment-cadence]');
        const shipping = island?.querySelector('[data-fas-payment-shipping]');
        const fullPrice = island?.querySelector('[data-fas-full-price]');
        const dialog = root.querySelector('[data-fas-cart-dialog]');
        const cartInfo = dialog?.querySelector('[data-fas-cart-payment-info]');
        const message = cartInfo?.querySelector('[data-fas-paypal-message]');
        const details = cartInfo?.querySelector('[data-fas-payment-details]');
        const cartAmount = dialog?.querySelector('[data-fas-cart-total]');
        const cartLabel = dialog?.querySelector('[data-fas-cart-price-label]');
        if (!island || !price || !amount || !cadence || !dialog || !cartInfo || !message) continue;
        let quote = null, pair = true, disposed = false, mounted = false, messageFailed = false;
        let cart = { total: 0, currency: island.dataset.fasPaymentCurrency, available: false };
        const sdkReady = () => !!win.PayPalSDK?.Messages;
        const updatePrice = () => {
          const plan = quote && sdkReady() && installmentQuote(quote.total, island.dataset.fasPaymentCurrency);
          price.hidden = !plan;
          island.classList.toggle('fg-has-installments', !!plan);
          if (fullPrice) fullPrice.hidden = !quote || !!plan;
          if (shipping) shipping.hidden = !quote || pair;
          if (plan) {
            amount.textContent = new Intl.NumberFormat(doc.documentElement.lang || 'es-ES', { style: 'currency', currency: island.dataset.fasPaymentCurrency }).format(plan.amount / 100);
            cadence.textContent = plan.equal ? cadence.dataset.equalLabel : cadence.dataset.fromLabel;
          }
        };
        const updateCart = () => {
          const plan = cart.available && sdkReady() && !messageFailed && installmentQuote(cart.total, cart.currency);
          const valid = !!plan;
          cartInfo.hidden = !valid;
          const money = cents => new Intl.NumberFormat(doc.documentElement.lang || 'es-ES', { style: 'currency', currency: cart.currency }).format(cents / 100);
          if (cartAmount) cartAmount.textContent = cart.known === false ? '—' : money(plan ? plan.amount : cart.total);
          if (cartLabel) cartLabel.textContent = plan ? (plan.equal ? cartLabel.dataset.equalLabel : cartLabel.dataset.fromLabel) : cartLabel.dataset.totalLabel;
          dialog.classList.toggle('fg-cart-has-installments', valid);
          if (!valid || disposed) return;
          message.setAttribute('data-pp-currency', cart.currency);
          message.setAttribute('data-pp-amount', (cart.total / 100).toFixed(2));
          if (mounted || !dialog.open || (details && !details.open)) return;
          mounted = true;
          const fail = () => { messageFailed = true; updateCart(); };
          try { win.PayPalSDK.Messages().render(message).catch(fail); } catch (_) { fail(); }
        };
        const selectionChanged = event => {
          // Preview-only letter events do not carry a commerce quote.
          if (!Object.prototype.hasOwnProperty.call(event.detail || {}, 'quote')) return;
          quote = event.detail.quote;
          pair = quote?.pair === true;
          updatePrice();
        };
        const cartChanged = event => { cart = event.detail; updateCart(); };
        const sdkLoaded = () => { updatePrice(); updateCart(); };
        const sdkScript = doc.querySelector('script[data-namespace="PayPalSDK"]');
        const observer = new win.MutationObserver(updateCart);
        observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
        root.addEventListener('fas:selection', selectionChanged);
        root.addEventListener('fas:cart-payment', cartChanged);
        details?.addEventListener('toggle', updateCart);
        sdkScript?.addEventListener('load', sdkLoaded, { once: true });
        controllers.set(root, () => {
          disposed = true;
          observer.disconnect();
          root.removeEventListener('fas:selection', selectionChanged);
          root.removeEventListener('fas:cart-payment', cartChanged);
          details?.removeEventListener('toggle', updateCart);
          sdkScript?.removeEventListener('load', sdkLoaded);
        });
      }
    }
    doc.addEventListener('shopify:section:load', event => initialize(event.target));
    doc.addEventListener('shopify:section:unload', event => {
      for (const [root, cleanup] of controllers) if (event.target === root || event.target.contains(root)) { cleanup(); controllers.delete(root); }
    });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', () => initialize(doc), { once: true });
    else initialize(doc);
  }
  return { installmentQuote, mount };
});
